export default {
  currency: {
    style: 'decimal',
    currency: 'NOK',
    minimumFractionDigits: 2,
  },
};



// WEBPACK FOOTER //
// ./src/app/numberFormats/no/index.js